addEventListener("DOMContentLoaded", (event) => {

// Add 'is-active' class on button click
document.querySelectorAll('.personalization a.btn').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('.popup-wrapper').classList.add('is-active');
  });
});

// Remove 'is-active' class on span click
document.querySelectorAll('.cs-popup > span').forEach(function(span) {
  span.addEventListener('click', function() {
    document.querySelector('.popup-wrapper').classList.remove('is-active');
  });
});


document.querySelectorAll('.ps-tab-button').forEach(button => {
 button.addEventListener('click', function() {
   document.querySelectorAll('.ps-tab-button').forEach(btn => btn.classList.remove('ps-active'));
   document.querySelectorAll('.ps-tab-pane').forEach(content => content.classList.remove('ps-active'));
   button.classList.add('ps-active');
   const tabId = button.getAttribute('data-tab');
   document.getElementById(tabId).classList.add('ps-active');
   const personalizationText = document.querySelector('#personalization-text');
   if (personalizationText) {
     personalizationText.classList.remove('ps-monogram', 'ps-text');
     personalizationText.classList.add(tabId);
   }

   const inputs = document.querySelectorAll('.ps-personalizaion-input');
   const messageElement = document.querySelector('.ps-personalization small');
   const isTextTab = tabId === 'ps-text';

   inputs.forEach(input => {
     const maxLength = isTextTab ? 15 : 3;
     input.setAttribute('maxlength', maxLength);
     
     if (input.value.length > maxLength) {
       input.value = input.value.slice(0, maxLength);
     }
   });

   if (isTextTab) {
     messageElement.textContent = '*1-15 Characters—letters, numbers, or keyboard symbols';
     
     const ludlowCheckbox = document.querySelector('label.ps-typeface-option.ludlow input');
     if (ludlowCheckbox) {
       ludlowCheckbox.checked = true;
       ludlowCheckbox.dispatchEvent(new Event('input'));
     }
   } else {
     messageElement.textContent = '*3 Letters—First Initial, Last Initial, Middle Initial';
     
     const personalizationTextDiv = document.querySelector('#personalization-text');
     if (personalizationTextDiv) {
       while (personalizationTextDiv.children.length > 3) {
         personalizationTextDiv.removeChild(personalizationTextDiv.lastChild);
       }
     }
   }
 });
});

document.querySelectorAll('.ps-personalizaion-input').forEach(input => {
 input.addEventListener('input', function() {
   const maxLength = document.querySelector('.ps-tab-button.ps-active').getAttribute('data-tab') === 'ps-text' ? 15 : 3;
   if (input.value.length > maxLength) {
     input.value = input.value.slice(0, maxLength);
   }
 });
});


document.querySelectorAll('.ps-typeface-input').forEach(input => {
  input.addEventListener('input', function() {
    const value = input.value;
    const handleizedValue = value
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
    const typefaceLabels = document.querySelectorAll('.ps-typeface-section > p');
    typefaceLabels.forEach(typefaceLabel => {
      typefaceLabel.textContent = `TYPEFACE: ${value}`;
    });
    const personalizationText = document.getElementById('personalization-text');
    if (personalizationText) {
      const preservedClasses = ['ps-monogram', 'ps-text'];
      const currentClasses = Array.from(personalizationText.classList);
      currentClasses.forEach(className => {
        if (!preservedClasses.includes(className)) {
          personalizationText.classList.remove(className);
        }
      });
      personalizationText.classList.add(handleizedValue);
    }
  });
});





document.querySelector('.ps-personalizaion-input').addEventListener('input', function() {
  const input = this; // The input element
  const personalizationText = document.getElementById('personalization-text'); // The container for the characters
  
  // Clear the current content of #personalization-text
  personalizationText.innerHTML = '';

  // Loop through each character in the input value
  const inputValue = input.value;
  for (let i = 0; i < inputValue.length; i++) {
    // Create a span element for each character
    const charSpan = document.createElement('span');
    charSpan.classList.add('p-char', `pchar-${i + 1}`); // Add the p-char class and dynamic pchar-{count} class
    charSpan.textContent = inputValue[i]; // Set the text of the span to the current character

    // Append the span to #personalization-text
    personalizationText.appendChild(charSpan);
  }
});



document.querySelectorAll('.ps-thread-color-input').forEach(input => {
  input.addEventListener('change', function() {
    // Get the value of the selected radio input
    const value = input.value;

    // Get the data-color attribute value
    const color = input.getAttribute('data-color');

    // Update the HTML of the .ps-thread-color > p element
    const threadColorText = document.querySelector('.ps-thread-color > p');
    if (threadColorText) {
      threadColorText.textContent = `Thread color: ${value}`;
    }

    // Apply the color as CSS to #personalization-text
    const personalizationText = document.getElementById('personalization-text');
    if (personalizationText) {
      personalizationText.style.color = color;
    }
  });
});


document.addEventListener('product:variant-change', function (evt) {
  let variantID = evt.detail.variant;
  const personalizationInput = document.getElementById('cvariant'); 
  const personalizationBtn = document.querySelector('.personalization .btn'); 
  personalizationInput.value = variantID.id;
  if(variantID.available){
    personalizationBtn.classList.remove('soldout');
  }else{
    personalizationBtn.classList.add('soldout');
  }
});

const dispatchCustomEvent = (eventName, data = {}) => {
  const detail = {
    detail: data
  };
  const event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

const atcP = document.querySelector('.ps-cta-btn .product-form__cart-submit');

function getLineItemProperties(form) {
    const formData = new FormData(form);
    const properties = {};
    for (let [key, value] of formData.entries()) {
        // Exclude the standard product options (like variant IDs) if needed
        if (!['id', 'quantity','terms'].includes(key)) {
            properties[key] = value;
        }
    }
    return properties;
}

function addToCart(variantIds, properties) {
    const items = variantIds.map(variantId => ({
        id: variantId,
        quantity: 1,
        properties: properties, // Attach line item properties here
    }));

    atcP.classList.add('loading');
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
    })
    .then(response => response.json())
    .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart },
            bubbles: true
        }));
        document.querySelector('.popup-wrapper').classList.remove('is-active');
        quickCart.open();
        atcP.classList.remove('loading');
    })
    .catch(error => {
        console.error('Error adding items to cart:', error);
        atcP.classList.remove('loading');
    });
}

atcP.addEventListener('click', function (event) {
    event.preventDefault();
    
    const v1 = document.getElementById('cvariant');
    const v2 = document.getElementById('cstmp');
    const customizationForm = document.querySelector('#cstomization');

    if (customizationForm) {
        const properties = getLineItemProperties(customizationForm);
        addToCart([v1.value, v2.value], properties);
    } else {
        console.error('Customization form not found');
    }
});


document.addEventListener('cart:open', (event) => {
  console.log('Cart open event triggered', event);
});

document.querySelectorAll('a').forEach(anchor => {
    anchor.addEventListener('click', event => {
        event.preventDefault();
        window.location.href = anchor.href;
    });
});


});